module.exports = __webpack_public_path__ + "img/ACT001.6496e9b1.png";